angular.module('pulseApp', ['ui.bootstrap','ui.router', 'firebase', 'angular-loading-bar', 'ngAnimate','ngMap','angularMoment']);

angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/home');

});

angular.module('pulseApp').run(function($rootScope) {



});
